import React from 'react'

export const DocumentFormView = () => {
  return (
    <div>DocumentFormView</div>
  )
}
